export default __webpack_public_path__ + "static/visually1-1d41a2899c93802db9ff60bbbdb30a64.png";